import {Injectable} from "@angular/core";
import AES from 'crypto-js/aes';
import Utf8 from "crypto-js/enc-utf8";
import {LocalStorageService} from "../storage/local-storage.service";

@Injectable({
  providedIn: 'root'
})
export class EncryptorService {

    constructor(protected storageService: LocalStorageService) {}

    public saveToLocalStorage(key: string, object: any, secret: string) {
        let ciphertext = AES.encrypt(JSON.stringify(object), secret);
        this.storageService.setItem(key, ciphertext.toString());
        return secret;
    }

    public readFromLocalStorage(key: string, secret: string) {
        let decryptedData = null;
        let ciphertext = this.storageService.getItem(key);
        if(ciphertext != null) {
            let bytes = AES.decrypt(ciphertext.toString(), secret);
            decryptedData = JSON.parse(bytes.toString(Utf8));
        }
        return decryptedData;
    }

    public readFromCipherText(ciphertext: string, secret: string) {
        let bytes  = AES.decrypt(ciphertext, secret);
        let decryptedData = JSON.parse(bytes.toString(Utf8));

        return decryptedData;
    }

    public guid() {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    }

}
